import FaqBanner from './faq-banner';

export default FaqBanner;
